module.exports = __webpack_public_path__ + "static/img/A126812@3x.a6a55f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/A1/A126812@3x.png
// module id = 5hBM
// module chunks = 0